<app-page-admin [isLoaded]="isLoaded">
  <router-outlet></router-outlet>
</app-page-admin>
